import { useParams } from "react-router";
import { useRelationshipsRelationshipShowQuery } from "@/services/backend/relationships/api/service";
import { useVbsWorkOrderShowQuery } from "@/services/backend/vbs/work-orders/api/work-order-api";
import { CalculationComponent } from "@/routes/processes/[processId]/vbs/calculations/[calculationId]/calculation/calculation-route";
import { NullUUID } from "@bitory-gmbh/nidavellir";

export function CalculationRoute() {
  const { relationshipId, commitmentId } = useParams();
  const { data: relationship } = useRelationshipsRelationshipShowQuery({
    id: relationshipId!,
  });

  const commitment = relationship?.commitments.find(
    (c) => c.id === commitmentId,
  );

  const { data: workOrder } = useVbsWorkOrderShowQuery({
    id: commitment?.documentId || NullUUID,
  });

  if (!workOrder) return null;

  return <CalculationComponent calculationId={workOrder.calculationId} />;
}
